import { Buffer } from 'buffer';

/**
 * Encodes a string to base64.
 * @param {string} str - The string to be encoded.
 * @returns {string} The base64-encoded string.
 * @note similar to "btoa" but see tests for difference, e.g.: with "null"
 * The first argument must be of type string or an instance of Buffer, ArrayBuffer, or Array or an Array-like Object.
 */
export const encodeStringToBase64 = str =>
    str ? Buffer.from(str).toString('base64') : '';
